import React from 'react'
import PoweredByAppykod from './PoweredByAppykod'

const BottomFooter = () => {
    return (
        <div className="bottom-footer bg-neutral-900 py-16 position-relative">
            <div className="container container-lg position-relative" style={{ zIndex: 1 }}>
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-12 mb-16 mb-lg-0">
                        <p className="text-gray-400 mb-0 text-center text-lg-start" style={{ fontSize: 'clamp(12px, 2vw, 14px)' }}>
                            Gümüş Pestil © 2025. Tüm hakları saklıdır.
                        </p>
                    </div>
                    
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="d-flex justify-content-center justify-content-lg-end align-items-center gap-16">
                            <span className="text-gray-400 fw-semibold" style={{ fontSize: 'clamp(12px, 2vw, 14px)' }}>
                                Güvenli Ödeme:
                            </span>
                            <div className="d-flex gap-12">
                                <div className="payment-method d-flex align-items-center justify-content-center bg-white rounded-8 px-12 py-8" 
                                     style={{ minWidth: '60px', height: '40px' }}>
                                    <img 
                                        src="/assets/images/brands/tekparca-logolar-2.jpg" 
                                        alt="Ödeme Seçenekleri" 
                                        className="payment-logo" 
                                        style={{ 
                                            maxHeight: "30px", 
                                            width: "auto",
                                            objectFit: "contain" 
                                        }}
                                    />
                                </div>
                                <div className="payment-method d-flex align-items-center justify-content-center bg-white rounded-8 px-12 py-8" 
                                     style={{ minWidth: '60px', height: '40px' }}>
                                    <img 
                                        src="/assets/images/brands/tekparca-logolar-1.jpg" 
                                        alt="Ödeme Seçenekleri" 
                                        className="payment-logo" 
                                        style={{ 
                                            maxHeight: "30px", 
                                            width: "auto",
                                            objectFit: "contain" 
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 d-flex justify-content-center mt-16 pt-16 border-top border-gray-800">
                        <PoweredByAppykod />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BottomFooter